table{width:100%}.col-md-4{margin-left:auto;margin-bottom:10px}.matwidth{width:fit-content;margin-right:20px}.mat-display{display:flex}
/*# sourceMappingURL=auth-log.component-Q46ZD244.css.map */
